import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import { initVoeThirdPartyCompanyForm} from "./form";

function initVoeThirdPartyCompanyCreate() {
	const accountForm = initVoeThirdPartyCompanyForm(document.querySelector('.third-party-companies-form'));

	document.querySelector('.create-new-third-party-company-button').onclick = createNewVoeThirdPartyCompany;

	/** Methods */

	function createNewVoeThirdPartyCompany() {
		accountForm.clearFeedbacks();

		loading();

		accountForm.submit()
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading);
	}
}

export {initVoeThirdPartyCompanyCreate}
